module.exports = __webpack_public_path__ + "img/GreyInterP.3de1e427.svg";